import { makeStyles } from "@mui/styles";
import { Services1, SupportImage, TrainingImage } from "../../images";

export const useStyles = makeStyles((theme) => ({
	gridBorder: {
		border: "2.5px solid #00CC8F",
		width: "11.813rem",
		height: "2.5px",
		marginTop: "2.125rem",
		marginBottom: "2.125rem",
	},
	servicesText: {
		fontSize: "3rem !important",
		fontWeight: 700,
		lineHeight: "3.75rem !important",
		fontFamily: "OutfitRegular",
		color: "#222222",
	},
	servicesImage1: {
		backgroundImage: `url(${Services1})`,
		//backgroundSize: "cover",
		backgroundRepeat: "no-repeat",
		objectFit: "fill",
		backgroundSize: "contain",
		backgroundPosition: "center",
		//paddingTop: "10rem",
		//paddingBottom: "10rem",
	},
	professionalText: {
		fontSize: "2.125rem !important",
		fontWeight: 600,
		lineHeight: "2.688rem !important",
		fontFamily: "OutfitRegular",
		color: "#0B3192",
	},
	professionalMetaText: {
		fontSize: "1.5rem !important",
		fontWeight: 400,
		lineHeight: "2.5rem !important",
		fontFamily: "OutfitRegular",
		color: "#555555",
	},
	gridGrid: {
		width: "6.25rem",
		height: "2px",
		marginTop: "0.875rem",
		marginBottom: "0.875rem",
	},
	gridBorderPro: {
		background: "#00CC8F",
		width: "6.25rem",
		height: "2px",
	},
	supportText: {
		fontSize: "2.125rem !important",
		fontWeight: 600,
		lineHeight: "2.688rem !important",
		fontFamily: "OutfitRegular",
		color: "#0B3192",
		[theme.breakpoints.down("sm")]: {
			fontSize: "2rem !important",
			lineHeight: "2rem !important",
		},
	},
	supportMetaText: {
		fontSize: "1.5rem !important",
		fontWeight: 400,
		lineHeight: "2.5rem !important",
		fontFamily: "OutfitRegular",
		color: "#555555",
		[theme.breakpoints.down("sm")]: {
			fontSize: "1.2rem !important",
			lineHeight: "2rem !important",
		},
	},
	supportImage: {
		backgroundImage: `url(${SupportImage})`,
		//backgroundSize: "cover",
		backgroundRepeat: "no-repeat",
		objectFit: "fill",
		backgroundSize: "contain",
		backgroundPosition: "center",
	},
	trainingImage: {
		backgroundImage: `url(${TrainingImage})`,
		backgroundRepeat: "no-repeat",
		objectFit: "fill",
		backgroundSize: "contain",
		backgroundPosition: "center",
		[theme.breakpoints.down("sm")]: {
			padding: "6.25rem 0",
		},
	},
	trainingsContainer: {
		paddingBottom: "6.25rem",
		[theme.breakpoints.down("sm")]: {
			paddingTop: "6.25rem",
		},
	},
}));
